<div (mouseenter)="showHelpText()" (mouseleave)="hideHelpText()" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
  @if (!hoverText) {
    <mat-icon
              [ngClass]="{'help-text__small-icon': isSmallIcon,
                          'help-text__medium-icon': isMediumIcon,
                          'help-text__3p-size': is3pSize,
                          'help-text__red-icon': displayRedText}">
      {{icon}}
    </mat-icon>
  }
  @if (hoverText) {
    <span>{{hoverText}}</span>
  }
  <div [hidden]="!show"
    fxLayout="column"
    fxLayoutAlign="start start"
    class="help-text__body"
         [ngClass]="{'help-text__left-display': displayOnLeft,
                     'help-text__center-display': displayInCenter,
                     'help-text__top-display': displayAbove,
                     'help-text__red-display': displayRedText}">
    @if (helpText) {
      <div [ngClass]="{'help-text__block-display-text': blockDisplay}" [innerHtml]="helpText"></div>
    }
    @if (filterText && filterText.length > 0) {
      <div
        class="help-text__sub-section-margin">
        @for (filter of filterText; track filter; let i = $index) {
          <div
            class="help-text__filter-text"
            [ngClass]="{'help-text__filter-text-margin' : i != (filterText.length - 1)}">
            {{filter}}
          </div>
        }
      </div>
    }
    @if (strategicGuidanceText) {
      <div
        class="help-text__sub-section-margin">
        {{strategicGuidanceText}}
      </div>
    }
  </div>
</div>
